import {
  types,
  CapabilitiesSummeryActionsType,
  ICapabilitiesSummaryState,
} from '../types/capabilitiesSummary'

export const initialState: ICapabilitiesSummaryState = {
  isLoading: false,
  groups: {},
}

export const capabilitiesSummary = (
  state = initialState,
  action: CapabilitiesSummeryActionsType
): ICapabilitiesSummaryState => {
  switch (action.type) {
    case types.GET_CAPABILITIES_SUMMARY__START:
      return {
        ...state,
        isLoading: true,
      }
    case types.GET_CAPABILITIES_SUMMARY__SUCCESS:
      return {
        isLoading: false,
        groups: { ...state.groups, [action.groupId]: action.data },
      }
    case types.GET_CAPABILITIES_SUMMARY__CANCEL:
    case types.GET_CAPABILITIES_SUMMARY__FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}
